import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { SessionCompany } from '@core/auth/auth-session.model';
import {
  companyBrandFallbackColor,
  companyInitials,
  companyMembershipLabelKey,
} from '@core/auth/company-membership-label.util';

@Component({
  selector: 'app-workspace-company-card',
  standalone: true,
  imports: [TranslateModule, TablerIconsModule],
  templateUrl: './workspace-company-card.component.html',
  styleUrl: './workspace-company-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkspaceCompanyCardComponent {
  readonly company = input.required<SessionCompany>();
  readonly active = input(false);
  readonly showLocationsSoon = input(true);

  readonly selected = output<SessionCompany>();

  private readonly logoBroken = signal(false);

  readonly roleKey = computed(() => companyMembershipLabelKey(this.company().roleName));
  readonly initials = computed(() => companyInitials(this.company().name));
  readonly brandColor = computed(() =>
    companyBrandFallbackColor(this.company().id, this.company().primaryColor)
  );
  readonly logoUrl = computed(() => {
    const url = this.company().logoUrl?.trim() || '';
    return this.logoBroken() ? '' : url;
  });
  readonly slugLabel = computed(() => {
    const slug = this.company().slug?.trim();
    return slug ? `milinco.app/${slug}` : '';
  });

  constructor() {
    effect(() => {
      void this.company().logoUrl;
      this.logoBroken.set(false);
    });
  }

  onLogoError(): void {
    this.logoBroken.set(true);
  }

  onSelect(): void {
    this.selected.emit(this.company());
  }
}
